<template>
    <div class="container">
        <div class="toolbar shadow-sm">
            <img src="@/assets/icons/StatsIcon.png" />
            <span class="title">{{ $t("admin.statistics.statistics_title") }}</span>

            <button class="btn btn-outline-primary dropdown-toggle" type="button" id="yearsDropDown" data-bs-toggle="dropdown" aria-expanded="false">
                {{ this.selectedYear }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="yearsDropDown">
                <li v-for="year of availableYears" v-bind:key="year"><a v-bind:class="yearDropDownItemClass(year)" href="#" v-on:click="handleDropDownYearSelected(year)">{{ year }}</a></li>
            </ul>
        </div>
        <div class="static-notes alert alert-warning" v-html="$t('admin.static_notes.statistics_outdated')"></div>


        <div class="scrolling-container">
            <div class="stats-container">
                <div v-for="statsElement of this.statsElements" v-bind:key="statsElement.id" v-bind:class="statsElement.className">{{ statsElement.value }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import StatisticsService from "@/service/StatisticsService.js";
import MapService from "@/service/MapService.js";
import PublisherService from "@/service/PublisherService.js";
import LangUtils from '../../../utils/LangUtils';

export default {
    data() {
        return {
            selectedPublisher: this.$store.state.currentPublisher,
            selectedYear: new Date().getFullYear(),
            statsElements: null,
            lexicalEntries: {},

            statisticsService: new StatisticsService(),
            mapService: new MapService(),
            publisherService: new PublisherService()
        }
    },

    computed: {
        availableYears() {
            var years = [];
            for (var year = 2021; year <= new Date().getFullYear(); year ++) {
                years.push(year);
            }

            return years;
        }
    },

    watch: {
        selectedYear: function() {
            this.loadStats();
        }
    },

    methods: {
        loadStats() {
            if (this.selectedPublisher) {
                this.statisticsService.loadPublisherYearBasicStatistics(this.selectedPublisher.id, this.selectedYear).then((basicStats) => {
                    this.publisherService.loadPublisherLexical(this.selectedPublisher.id).then((lexicalEntries) => {
                        this.lexicalEntries = lexicalEntries;

                        const allSections = [];

                        for (const basicStat of basicStats) {
                            const section = this.findOrCreateSectionForEvent(basicStat.category, basicStat.event, basicStat.objectId, allSections);
                            if (this.lexicalEntries[basicStat.objectId]) {
                                const row = this.findOrCreateRowForStat(basicStat, section);

                                if (row.values[basicStat.month]) {
                                    row.values[basicStat.month] = row.values[basicStat.month] + basicStat.value;
                                } else {
                                    row.values[basicStat.month] = basicStat.value;
                                }
                            }
                        }

                        this.statsElements = this.transformSectionsToGrid(allSections);
                    }).catch((error) => {
                        console.log(error);
                    });
                }).catch((error) => {
                    console.log(error);
                });
            }
        },

        yearDropDownItemClass(year) {
            if (this.selectedYear == year) {
                return "dropdown-item dropdown-item-checked";
            } else {
                return "dropdown-item dropdown-item-not-checked";
            }
        },

        handleDropDownYearSelected(year) {
            this.selectedYear = year;
        },

        findOrCreateSectionForEvent(category, event, objectId, allSections) {
            var result = null;

            const sectionIdToFind = category + "_" + event;

            var eventSection = null;
            for (const section of allSections) {
                if (section.id == sectionIdToFind) {
                    eventSection = section;
                    break;
                }
            }

            if (eventSection == null) {
                eventSection = {
                    id: category + "_" + event,
                    type: "event",
                    level: 0,
                    sections: [],
                    rows: []
                };
                allSections.push(eventSection);
            }

            const isObjectSection = objectId.indexOf(".") >= 0;
            if (isObjectSection) {
                var parentSection = eventSection;

                var level = eventSection.level + 1;

                const objectIdsParts = objectId.split(".");
                for (var i = 0; i < objectIdsParts.length - 1; i ++) {
                    var objectIdToFind = objectIdsParts[i];
                    
                    var foundSection = null;
                    for (const section of parentSection.sections) {
                        if (section.id == category + "_" + event + "_" + objectIdToFind) {
                            foundSection = section;
                            break;
                        }
                    }

                    if (foundSection != null) {
                        parentSection = foundSection;
                    } else {
                        const newSection = {
                            id: category + "_" + event + "_" + objectIdToFind,
                            objectId: objectIdToFind,
                            name: this.lexicalEntries[objectIdToFind] ? LangUtils.valueForLanguage(this.lexicalEntries[objectIdToFind].name, this.$i18n.locale) : "N/A",
                            type: "object",
                            level: level,
                            sections: [],
                            rows: []
                        };
                        parentSection.sections.push(newSection);
                        parentSection = newSection;
                    }

                    level = level + 1;
                }

                result = parentSection;
            } else {
                result = eventSection;
            }

            return result;
        },

        findOrCreateRowForStat(stat, section) {
            var result = null;

            var objectIdToFind;
            if (stat.objectId.indexOf(".") >= 0) {
                const objectIdParts = stat.objectId.split(".");
                objectIdToFind = objectIdParts[objectIdParts.length - 1];
            } else {
                objectIdToFind = stat.objectId;
            }

            for (const row of section.rows) {
                if (row.objectId == objectIdToFind) {
                    result = row;
                    break;
                }
            }
            
            if (result == null) {
                result = {
                    objectId: objectIdToFind,
                    name: this.lexicalEntries[stat.objectId] ? LangUtils.valueForLanguage(this.lexicalEntries[stat.objectId].name, this.$i18n.locale) : "N/A",
                    values: {}
                };
                section.rows.push(result);
            }

            return result;
        },

        transformSectionsToGrid(allSections) {
            const result = [];

            result.push({
                id: "empty_top_left",
                className: "empty-top-left",
                value: ""
            });

            for (var monthId = 1; monthId <= 12; monthId ++) {
                result.push({
                    id: "month_" + monthId,
                    className: ((monthId % 2) ? "month-name-odd" : "month-name-even") + " shadow-sm",
                    value: this.$t("enums.monthsByNumber." + monthId)
                });
            }

            const sectionsToProcess = [];
            for (const section of allSections) {
                this.flattenSections(section, sectionsToProcess);
            }

            for (const section of sectionsToProcess) {
                result.push({
                    id: section.id,
                    className: "section-name-level-" + section.level + " shadow-sm",
                    value: this.sectionName(section)
                });

                if (section.rows.length > 0) {
                    for (const row of section.rows) {
                        result.push({
                            id: section.id + "_" + row.objectId,
                            className: "row-name shadow-sm",
                            value: row.name ? row.name : row.objectId
                        });
                        for (var i = 1; i <= 12; i++) {
                            result.push({
                                id: section.id + "_" + row.objectId + "_" + i,
                                className: ((i % 2) ? "row-value-odd" : "row-value-even") + " shadow-sm",
                                value: row.values[i] ? row.values[i] : ""
                            });
                        }
                    }
                }
            }

            return result;
        },

        flattenSections(parentSection, result) {
            result.push(parentSection);

            if (parentSection.sections.length > 0) {
                for (const section of parentSection.sections) {
                    this.flattenSections(section, result);
                }
            }
        },

        sectionName(section) {
            if (section.type == "event") {
                return this.$t("admin.statistics.names." + section.id);
            } else {
                return section.name ? section.name : section.objectId;
            }
        }
    },

    mounted() {
        this.$store.subscribe( (mutation) => {
            if (mutation.type == "setCurrentPublisher") {
                this.selectedPublisher = mutation.payload;
                this.loadStats();
            }
        });

        this.loadStats();
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    margin: 0px;
    max-width: none;
}

.toolbar {
    background-color: #ffffff;
    margin-bottom: 8px;
    padding: 8px;
    padding-left: 24px;
    text-align: left;
    width: 100%;
}

.toolbar img {
    margin-right: 16px;
    width: 50px;
}

.toolbar .title {
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin-right: 36px;
    max-width: 250px;
}

.toolbar button {
    margin: 0px 4px;
}

.dropdown-item-checked::before {
  left: .4rem;
  content: '✓';
  font-weight: 600;
  margin-right: 8px;
}

.dropdown-item-not-checked::before {
  left: .4rem;
  content: '✓';
  font-weight: 600;
  color: #ffffff00;
  margin-right: 8px;
}

.scrolling-container {
    width: 100%;
    height: 100%;
    overflow: scroll;
}

.stats-container {
    display: grid;
    grid-template-columns: auto 7.5% 7.5% 7.5% 7.5% 7.5% 7.5% 7.5% 7.5% 7.5% 7.5% 7.5% 7.5%;
    margin-bottom: 32px;
}

.month-name-odd {
    background-color: #555555;
    color: #ffffff;
    font-weight: bold;
    margin-top: 16px;
    padding: 2px 0px;
}

.month-name-even {
    background-color: #555555;
    color: #ffffff;
    font-weight: bold;
    margin-top: 16px;
    padding: 2px 0px;
}

.section-name-level-0 {
    background-color: #999999;
    color: #ffffff;
    font-weight: bold;
    grid-column: 1 / span 13;
    margin-top: 16px;
    padding: 2px 8px;
    text-align: left;
}

.section-name-level-1 {
    background-color: #cccccc;
    color: #333333;
    font-weight: bold;
    grid-column: 1 / span 13;
    padding: 2px 16px;
    text-align: left;
}

.stat-name {
    grid-column: 1 / span 13;
    text-align: left;
}

.object-name {
    grid-column: 1 / span 13;
    text-align: left;
}

.row-name {
    background-color: #ffffff;
    border-right: 1px solid #dddddd;
    border-top: 1px solid #dddddd;
    font-weight: bold;
    padding: 2px 8px;
    text-align: left;
}

.row-value-odd {
    background-color: #ffffff;
    border-top: 1px solid #dddddd;
    color: #555555;
    padding: 2px 0px;
}

.row-value-even {
    background-color: #f5f5f5;
    border-top: 1px solid #dddddd;
    color: #555555;
    padding: 2px 0px;
}

.months-container {
    display: grid;
    grid-template-columns: auto auto auto auto;
    row-gap: 16px;
    column-gap: 16px;
}

.month-box {
    background: #ffffff;
    height: 250px;
}

.month-box h3 {
    font-size: 18px;
    font-weight: bold;
    margin: 16px 0px;
    padding: 0px 16px;
    text-align: left;
}

.month-box .stats-container {
    display: grid;
    grid-template-columns: auto auto;
    margin: 0px 32px;
}

.month-box .stats-container .stat-name {
    text-align: left;
}

.month-box .stats-container .stat-value {
    text-align: right;
}
.static-notes {
  text-align: left;
  font-size: 0.8rem;
}
</style>
